import React from 'react';
import { AbsProduct, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import AbsContextProvider from '@/creditflowresearch/application/Deal/contexts/IssueTile/AbsContext';
import CorporateContextProvider from '@/creditflowresearch/application/Deal/contexts/IssueTile/CorporateContext';
import DealRepository from '@/creditflowresearch/infrastructure/repository/DealRepository';
import { IDealFetchResult } from '@/creditflowresearch/application/Deal/helpers/dealFetcher/types/IDealFetcher';

interface IContextConfig {
  productType: string,
  Provider: React.ComponentType<any>,
  fetch: (payload: any) => Promise<any>,
}

interface IProductTypeConfig {
  productType: string,
  productIds: string[],
  Provider: React.ComponentType<any>,
  getFetchMethod: (dealRepository: DealRepository) => (payload: any) => Promise<any>,
}

const PRODUCT_TYPE_CONFIGS: IProductTypeConfig[] = [
  {
    productType: AbsProduct.ABBREVIATION.toLowerCase(),
    productIds: [AbsProduct.PRODUCT_ID],
    Provider: AbsContextProvider,
    getFetchMethod: (dealRepository) => async (payload) => {
      const response = await dealRepository.getDealsWithSubscriptionStatus(payload);

      return {
        collection: response.deals.collection,
        totalCount: response.deals.totalCount,
        subscriptionStatus: response.subscriptionStatus,
      };
    },
  },
  {
    productType: 'corporate',
    productIds: [HycProduct.PRODUCT_ID, IgcProduct.PRODUCT_ID],
    Provider: CorporateContextProvider,
    getFetchMethod: (dealRepository) => dealRepository.getCorporateDealsWithSubscription,
  },
];

export const createContextConfigs = (
  productIds: string[],
  dealRepository: DealRepository,
): IContextConfig[] => {
  return PRODUCT_TYPE_CONFIGS
    .filter((config) => config.productIds.some((id) => productIds.includes(id)))
    .map((config) => ({
      productType: config.productType,
      Provider: config.Provider,
      fetch: config.getFetchMethod(dealRepository),
    }));
};

export const prepareDealDataForProductType = (deals: IDealFetchResult, productType: string) => {
  const dealData = deals[productType];

  return {
    ...dealData,
  };
};
